import styled, { css } from 'styled-components'

export interface ClearButtonStyledProps {
  $size?: 'small' | 'medium' | 'large'
}

const sizeStyles = {
  small: css`
    width: 16px;
    height: 16px;
    font-size: ${({ theme }) => theme.typography.fontSize.micro};
    border-radius: ${({ theme }) => theme.borderRadius.small};
  `,
  medium: css`
    width: 20px;
    height: 20px;
    font-size: ${({ theme }) => theme.typography.fontSize.small};
    border-radius: ${({ theme }) => theme.borderRadius.small};
  `,
  large: css`
    width: 24px;
    height: 24px;
    font-size: ${({ theme }) => theme.typography.fontSize.body};
    border-radius: ${({ theme }) => theme.borderRadius.default};
  `,
}

export const Button = styled.button<ClearButtonStyledProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text.secondary};
  transition: ${({ theme }) => theme.transitions.default};
  padding: 0;
  line-height: 1;
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};
  font-weight: ${({ theme }) => theme.typography.fontWeight.normal};
  flex-shrink: 0;

  ${({ $size = 'medium' }) => sizeStyles[$size]}

  &:hover:not(:disabled) {
    color: ${({ theme }) => theme.colors.text.primary};
    background: ${({ theme }) => theme.colors.background.secondary};
  }

  &:focus {
    outline: none;
    color: ${({ theme }) => theme.colors.text.primary};
    background: ${({ theme }) => theme.colors.background.secondary};
    box-shadow: ${({ theme }) => theme.shadows.focus};
  }

  &:active:not(:disabled) {
    background: ${({ theme }) => theme.colors.background.tertiary};
    transform: scale(0.95);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    color: ${({ theme }) => theme.colors.text.tertiary};
  }
`
